import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Menu, MenuItem } from '@mui/material';
import { AccessType } from '../../model/Reformulary';
import GetLangConfig from '../../util/LangUtil';
import './header.css';
import LanguageToggle from '../../components/LanguageToggle';

export default function Header() {
    const userId = JSON.parse(sessionStorage.getItem('userId') || 'null');
    const userIdentityObject = JSON.parse(sessionStorage.getItem('userIdentityObject') || 'null');
    const langConfig = GetLangConfig('header');
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const history = useNavigate();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        sessionStorage.clear();
        history("/landing");
    };

    const handleSettings = () => {
        setAnchorEl(null);
        if (!userId || !userId.role) return;

        const role = userId.role;
        let redirectPath = "/settings";
        if (role === AccessType[AccessType.MEMBER_CLAIMANT_ACCESS] || role === AccessType[AccessType.NON_MEMBER_CLAIMANT_ACCESS]) {
            redirectPath = "/settings";
        } else if (role === AccessType[AccessType.ADMIN_ACCESS]) {
            redirectPath = "/admin/settings";
        } else if (role === AccessType[AccessType.ASSESSOR_ACCESS]) {
            redirectPath = "/assessor/settings";
        }
        history(redirectPath);
    };

    if (window.location.hash === "#/") return null; // Prevent rendering on the landing page

    return (
        <div className="page-header">
            <div><img src={langConfig?.general.logo} alt="Logo" /></div>
            <div>
                {userId && userIdentityObject ? (
                    <div>
                        <Button
                            id="menu-button"
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={handleClick}
                        >
                            <i className="down"></i> {userIdentityObject.firstName} {userIdentityObject.lastName}
                        </Button>
                        <Menu
                            id="user-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                        >
                            <MenuItem onClick={handleSettings}>{langConfig.header.settings}</MenuItem>
                            <MenuItem onClick={handleLogout}>{langConfig.header.logout}</MenuItem>
                        </Menu>
                    </div>
                ) : null}
            </div>
            <div>
                <LanguageToggle />
            </div>
        </div>
    );
}